// extracted by mini-css-extract-plugin
export default {"main":"SectionB_main__YxNII","sectionB":"SectionB_sectionB__ZVE9l","card":"SectionB_card__A4dH7","imgCard":"SectionB_imgCard__g7H+o","image":"SectionB_image__DtMnT"};